exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden{display:none}.info_columns{display:flex}.info_columns .col-left{padding-right:15px;width:50%}.info_columns .col-right{width:50%}.schedule{list-style:none;margin:0 0 40px;padding:0}.schedule .schedule-item{display:flex}.schedule-status{padding-bottom:25px;width:50%}.schedule_day{font-weight:700;width:50%}.download-catering{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f2b0fcf","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/LocationDetails.vue
// module id = 161
// module chunks = 0